var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Trash2 = function Trash2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM15 11a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 2a2 2 0 0 0-2 2v2H4a1 1 0 0 0 0 2h.08L5 19.046A3 3 0 0 0 8 22h8a3 3 0 0 0 3-2.954L19.92 8H20a1 1 0 1 0 0-2h-4V4a2 2 0 0 0-2-2h-4Zm4 4V4h-4v2h4ZM6.087 8l.91 10.917A1 1 0 0 1 7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 1 .003-.083L17.913 8H6.087Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Trash2;